<template>
    <div class="bg-color-granite pb-10">
        <div class="d-flex justify-center align-center w-100 position-relative">
            <v-img class="w-100 h-100"			
                :height="199"
                aspect-ratio="16/9"
                src="https://dellpartnerincentives.com/siteassets/Images/HomePartner/Banner/bgRISE2.jpg"
            ></v-img>
            <div class="position-absolute page-header">
                <h1><LanguagePlaceholder default-text="My Bonus Dashboard" /></h1>
            </div>			
        </div>
        <div class="bg-color-granite w-100 h-100">
            <div class="bg-color-quartz w-100 h-100 my-2">
                <v-row no-gutters class="d-flex justify-center w-100 pa-0 pt-3 bg-color-dell-blue tx-color-white">
                    <v-col cols="10" class="d-flex flex-column justify-start flex-column w-100 pa-8 tx-font-normal tx-font-size20">  
                        <div class="pb-10">
                            <LanguagePlaceholder  is-html
                                default-text="My Bonus Dashboard shows which bonuses you are eligible for" />
                        </div>

                        <div>
                            <v-select class="text-white w-25" v-model="selectedQuarter"
                                :items="quarters" variant="outlined"
                                aria-label="Select Incentive Period">
                                <template v-slot:label>                                                            	
                                    <LanguagePlaceholder is-html default-text="Select Incentive Period" />
                                </template>
                            </v-select>
                        </div>

                        <div class="ps-4">
                            <v-btn @click="clickSubmit" color="white" variant="outlined"><LanguagePlaceholder default-text="Submit" /></v-btn>
                        </div>
                    </v-col>
                </v-row>
            </div>
            <div class="bg-color-granite w-auto h-100 my-2 mx-10" >
                <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                <v-col cols="1" class="bg-color-quartz"></v-col>
                <v-col cols="10" class="d-flex justify-start w-100 pa-0 py-10 tx-font-bold bg-color-quartz">  
                    <v-toolbar color="#EEEEEE">
                        <v-toolbar-title>
                            <h1 class="tx-color-grey pa-2">
                                <LanguagePlaceholder default-text="My Current Performance" />
                            </h1>                                            
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon="mdi-download" @click="downloadFile" size="large" aria-label="Download Report"><v-icon>mdi-download</v-icon></v-btn>
                    </v-toolbar>   
                </v-col>
                <v-col cols="1" class="bg-color-quartz"></v-col>
                </v-row>
                <v-row no-gutters class="bg-color-quartz d-flex justify-center w-100 pa-0 pb-5">
                    <v-col cols="1" class="bg-color-quartz"></v-col>
                    <v-col cols="10" class="bg-color-white d-flex justify-center w-100 pa-0">  
                        <div class="ma-0 pa-0 w-100">
                            <v-data-table items-per-page="50" :headers="headers" :items="reportData"
                                    item-key="id" class="w-100 v-data-table-row">
                            </v-data-table>      
                        </div>            
                    </v-col>
                    <v-col cols="1" class="bg-color-quartz"></v-col>
                </v-row>
            </div>
            <div class="bg-color-granite w-auto h-100 my-2 mx-10" >
                <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                <v-col cols="1" class="bg-color-quartz"></v-col>
                <v-col cols="10" class="d-flex justify-start w-100 pa-0 py-10 tx-font-bold bg-color-quartz">  
                    <v-toolbar color="#EEEEEE">
                        <v-toolbar-title>
                            <h1 class="tx-color-grey pa-2">
                                <LanguagePlaceholder default-text="My Bonus Opportunities" />
                            </h1>                                            
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>   
                </v-col>
                <v-col cols="1" class="bg-color-quartz"></v-col>
                </v-row>
                <v-row no-gutters class="bg-color-quartz d-flex justify-center w-100 pa-0 pb-5">
                    <v-col cols="1" class="bg-color-quartz"></v-col>
                    <v-col cols="10" class="bg-color-white d-flex justify-center w-100 pa-0  tx-font-bold">  
                        <div class="bg-color-white tx-font-bold ma-0 pa-0">
                            <v-row>
                                <v-col cols="12" class="pa-10">
                                    <div class="d-flex justify-center flex-wrap justify-space-around">

                                        <v-card v-if="showOptiplex" class="h-33 w-33 mt-5" color="#9FDDFF">
                                            <v-img  src="https://dellpartnerincentives.com/siteassets/Images/OptiplexBonus.jpg"></v-img>
                                            <div class="pa-4 bg-color-royal tx-color-white">
                                                <h4>
                                                    <LanguagePlaceholder is-html
                                                        default-text="Account Plays - x2 Reward on OptiPlex​" />
                                                </h4>
                                            </div>
                                            <v-card-text class="pa-4 h-100 bg-color-pool tx-color-midnight">
                                                <div>
                                                    <p class="general-text">
                                                        <strong>
                                                            <LanguagePlaceholder is-html
                                                                default-text="Promotion Period:" />
                                                        </strong>
                                                    </p>
                                                    <p class="general-text">
                                                        <LanguagePlaceholder is-html
                                                            default-text="3 May 2025 - 1 August 2025" />
                                                    </p>
                                                </div>
                                                <br>
                                                <div>
                                                    <p class="general-text">
                                                        <strong>
                                                            <LanguagePlaceholder is-html
                                                                default-text="Rewards Available:" />
                                                        </strong>
                                                    </p>
                                                    <p class="general-text">
                                                        <LanguagePlaceholder is-html
                                                            default-text="x2 rewards on OptiPlex​" />
                                                    </p>
                                                </div>
                                                <br>
                                                <div>
                                                    <p class="general-text">
                                                        <strong>
                                                            <LanguagePlaceholder is-html
                                                                default-text="Eligibility Criteria:" />
                                                        </strong>
                                                    </p>
                                                    <p class="general-text">
                                                        <LanguagePlaceholder is-html
                                                            default-text="This offer is only available to SELECT partners who have not purchased any OptiPlex​ in the last 4 quarters​" />
                                                    </p>
                                                    <br>

                                                </div>
                                            </v-card-text>
                                        </v-card>

                                        <v-card v-if="showLatitude" class="h-33 w-33 mt-5" color="#9FDDFF">
                                                <v-img  src="https://dellpartnerincentives.com/siteassets/Images/LatitudeBonus.jpg"></v-img>
                                            <div class="pa-4 bg-color-royal tx-color-white">
                                                <h4>
                                                    <LanguagePlaceholder is-html
                                                        default-text="Account Plays - x3 Reward on Latitude​" />
                                                </h4>
                                            </div>
                                            <v-card-text class="pa-4 h-100 bg-color-pool tx-color-navy">
                                                <div class="">
                                                    <p class="general-text">
                                                        <strong>
                                                            <LanguagePlaceholder  is-html
                                                                default-text="Promotion Period:" />
                                                        </strong>
                                                    </p>
                                                    <p class="general-text">
                                                        <LanguagePlaceholder is-html
                                                            default-text="3 May 2025 - 1 August 2025" />
                                                    </p>
                                                </div>
                                                <br>
                                                <div>
                                                    <p class="general-text">
                                                        <strong>
                                                            <LanguagePlaceholder is-html
                                                                default-text="Rewards Available:" />
                                                        </strong>
                                                    </p>
                                                    <p class="general-text">
                                                        <LanguagePlaceholder is-html
                                                            default-text="x3 rewards on Latitude" />
                                                    </p>
                                                </div>
                                                <br>
                                                <div>
                                                    <p class="general-text">
                                                        <strong>
                                                            <LanguagePlaceholder is-html
                                                                default-text="Eligibility Criteria:" />
                                                        </strong>
                                                    </p>
                                                    <p class="general-text">
                                                        <LanguagePlaceholder is-html
                                                            default-text="This offer is only available to SELECT partners who have not purchased any Latitudes in the last 4 quarters​" />
                                                    </p>
                                                    <br>

                                                </div>
                                            </v-card-text>
                                        </v-card>

                                        <v-card v-if="showFPB" class="h-33 w-33 mt-5" color="#9FDDFF">
                                            <v-img src="https://dellpartnerincentives.com/siteassets/Images/FPBonus.jpg"></v-img>
                                            <div class="pa-4 bg-color-royal tx-color-white">
                                                <h4>
                                                    <LanguagePlaceholder is-html
                                                        default-text="First Purchase Bonus​​" />
                                                </h4>
                                            </div>
                                            <v-card-text class="pa-4 h-100 bg-color-pool tx-color-navy">
                                                <div class="">
                                                    <p class="general-text">
                                                        <strong>
                                                            <LanguagePlaceholder  is-html
                                                                default-text="Promotion Period:" />
                                                        </strong>
                                                    </p>
                                                    <p class="general-text">
                                                        <LanguagePlaceholder is-html
                                                            default-text="3 May 2025 - 1 August 2025" />
                                                    </p>
                                                </div>
                                                <br>
                                                <div>
                                                    <p class="general-text">
                                                        <strong>
                                                            <LanguagePlaceholder is-html
                                                                default-text="Rewards Available:" />
                                                        </strong>
                                                    </p>
                                                    <p class="general-text">
                                                        <LanguagePlaceholder is-html
                                                            default-text="$250 for Client Solutions, $125 for Server+ and $1000 for Storage +​​" />
                                                    </p>
                                                </div>
                                                <br>
                                                <div>
                                                    <p class="general-text">
                                                        <strong>
                                                            <LanguagePlaceholder is-html
                                                                default-text="Eligibility Criteria:" />
                                                        </strong>
                                                    </p>
                                                    <p class="general-text">
                                                        <LanguagePlaceholder is-html
                                                            default-text="Partners who have not purchased any Dell products within the given line of business for the last 4 quarters or are new to the Dell Technologies Partner Program will qualify for this bonus" />
                                                    </p>
                                                </div>
                                                <br>
                                                <div>
                                                    <p class="general-text">
                                                        <strong>
                                                            <LanguagePlaceholder is-html
                                                                default-text="Thresholds:" />
                                                        </strong>
                                                    </p>
                                                    <p class="general-text">
                                                        <LanguagePlaceholder is-html
                                                            default-text="Purchase 5 Client Solutions units, or​<br/>1 Server+ unit, or​<br/>$10,000 for Storage" />
                                                    </p>
                                                    <br>
                                                </div>
                                            </v-card-text>
                                        </v-card>

                                        <v-card class="h-33 w-33 mt-5" color="#9FDDFF">
                                            <v-img src="https://dellpartnerincentives.com/siteassets/Images/WorkstationBonus.jpg"></v-img>
                                            <div class="pa-4 bg-color-royal tx-color-white">
                                                <h4>
                                                    <LanguagePlaceholder is-html
                                                        default-text="Precision Workstation Bonus​" />
                                                </h4>
                                            </div>
                                            <v-card-text class="pa-4 bg-color-pool tx-color-navy">
                                                <div class="">
                                                    <p class="general-text">
                                                        <strong>
                                                            <LanguagePlaceholder is-html
                                                                default-text="Promotion Period:" />
                                                        </strong>
                                                    </p>
                                                    <p class="general-text">
                                                        <LanguagePlaceholder is-html
                                                            default-text="3 May 2025 - 1 August 2025" />
                                                    </p>
                                                </div>
                                                <br>
                                                <div class="h-100">
                                                    <p class="general-text">
                                                        <strong>
                                                            <LanguagePlaceholder is-html
                                                                default-text="Rewards Available:" />
                                                        </strong>
                                                    </p>
                                                    <p class="general-text">
                                                        <LanguagePlaceholder is-html
                                                            default-text="$300 / $600" />
                                                    </p>
                                                </div>
                                                <br>
                                                <div class="h-100">
                                                    <p class="general-text">
                                                        <strong>
                                                            <LanguagePlaceholder is-html
                                                                default-text="Eligibility Criteria:" />
                                                        </strong>
                                                    </p>
                                                    <p class="general-text">
                                                        <LanguagePlaceholder is-html
                                                            default-text="
                                                            Meet 1 of the 2 thresholds when purchasing Precision Workstations as SNS
                                                            <br><br>
                                                            <i>Threshold 1</i>
                                                            <br>
                                                            Minimum purchase amount: 8 units
                                                            <br>
                                                            Reward Value: $300
                                                            <br><br>
                                                            <i>Threshold 2</i>
                                                            <br>
                                                            Minimum purchase amount: 14 units
                                                            <br>
                                                            Reward Value: $600
                                                            " />
                                                    </p>
                                                    <br>
                                                    <p class="general-text">
                                                        <strong>
                                                            <LanguagePlaceholder is-html
                                                                default-text="THIS OFFER IS AVAILABLE TO ALL PARTNERS" />
                                                        </strong>
                                                    </p>
                                                </div>
                                            </v-card-text>
                                        </v-card>

                                        <v-card class="h-33 w-33 mt-5" color="#9FDDFF">
                                            <v-img src="https://dellpartnerincentives.com/siteassets/Images/GrowthBonus.jpeg"></v-img>
                                            <div class="pa-4 bg-color-royal tx-color-white">
                                                <h4>
                                                    <LanguagePlaceholder is-html
                                                        default-text="Growth Bonus​​" />
                                                </h4>
                                            </div>
                                            <v-card-text class="pa-4 bg-color-pool tx-color-navy">
                                                <div class="">
                                                    <p class="general-text">
                                                        <strong>
                                                            <LanguagePlaceholder is-html
                                                                default-text="Promotion Period:" />
                                                        </strong>
                                                    </p>
                                                    <p class="general-text">
                                                        <LanguagePlaceholder is-html
                                                            default-text="3 May 2025 - 1 August 2025" />
                                                    </p>
                                                </div>
                                                <br>
                                                <div class="h-100">
                                                    <p class="general-text">
                                                        <strong>
                                                            <LanguagePlaceholder is-html
                                                                default-text="Rewards Available:" />
                                                        </strong>
                                                    </p>
                                                    <p class="general-text">
                                                        <LanguagePlaceholder is-html
                                                            default-text="15% of your base and multiplier reward value added on as extra rewards​" />
                                                    </p>
                                                </div>
                                                <br>
                                                <div class="h-100">
                                                    <p class="general-text">
                                                        <strong>
                                                            <LanguagePlaceholder is-html
                                                                default-text="Eligibility Criteria:" />
                                                        </strong>
                                                    </p>
                                                    <p class="general-text">
                                                        <LanguagePlaceholder is-html
                                                            default-text="
                                                                When you increase your system unit purchases* by at least 10%, compared to the previous incentive period, you'll unlock an additional 15% in rewards, applied as a 1.15x multiplier on your core RISE earnings. 
                                                                <br><br>
                                                                A minimum threshold is required in each category, to be eligible for the Growth Bonus:​
                                                                <br><br>
                                                                &nbsp;&nbsp;&nbsp;&nbsp;Minimum 30 units for PCS​
                                                                <br><br>
                                                                &nbsp;&nbsp;&nbsp;&nbsp;Minimum 5 units Server​
                                                                <br><br>
                                                                &nbsp;&nbsp;&nbsp;&nbsp;Minimum 2 units Storage​
                                                                <br><br>
                                                                The first GROWTH BONUS will be paid out with Q2 rewards (increase will be measured vs Q1 performance). 
                                                            " />
                                                    </p>
                                                    <br>
                                                    <p class="general-text">
                                                        <strong>
                                                            <LanguagePlaceholder is-html
                                                                default-text="THIS OFFER IS AVAILABLE TO ALL PARTNERS" />
                                                        </strong>
                                                    </p>
                                                </div>
                                            </v-card-text>
                                        </v-card>

                                    </div>
                                </v-col>
                            </v-row>                        
                        </div>            
                    </v-col>
                    <v-col cols="1" class="bg-color-quartz"></v-col>
                </v-row>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onBeforeMount} from 'vue'
import { useSystemStore } from '@/stores/system'
import { useReportsStore } from '@/stores/reports'
import { useUserStore } from '@/stores/user'
import { useExcelStore } from '@/stores/excel'

import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'

const systemStore = useSystemStore()
const reportsStore = useReportsStore()
const userStore = useUserStore()
const excelStore = useExcelStore()

const selectedQuarter = ref('')

const quarters = ref([])

const reportData = ref([])
const headers = ref([])
const selectedReport = ref({})
const searchString = ref('')
const userId = ref(0)
const showFPB = ref(false)
const showLatitude = ref(false)
const showOptiplex = ref(false)

const defineHeaders = () => {

    if (systemStore.userDetail.userType.trim() != 'Partner') {
        headers.value.push(
        {
            title: `AffinityId`,
            value: `partnerAffinityId`,
            headerProps: { class: 'v-data-table-header' },
            sortable: true
        })

        headers.value.push(
        {
            title: `Partner`,
            value: `partnerName`,
            headerProps: { class: 'v-data-table-header' },
            sortable: true
        })
    }

    headers.value.push(
    {
        title: `Bonus Name`,
        value: `bonusName`,
        headerProps: { class: 'v-data-table-header' },
        sortable: true
    })
    
    headers.value.push(
    {
        title: `Units`,
        value: `units`,
        headerProps: { class: 'v-data-table-header' },
        sortable: true
    })

    headers.value.push(
    {
        title: `Unit Threshold`,
        value: `unitThresholdAndRewardValue`,
        headerProps: { class: 'v-data-table-header' },
        sortable: true
    })

    headers.value.push(
    {
        title: `Bonus Value`,
        value: `bonusValue`,
        headerProps: { class: 'v-data-table-header' },
        sortable: true
    })

    headers.value.push(
    {
        title: `Qualified`,
        value: `qualified`,
        headerProps: { class: 'v-data-table-header' },
        sortable: true
    })

    headers.value.push(
    {
        title: `Reasons`,
        value: `reasons`,
        headerProps: { class: 'v-data-table-header' },
        sortable: true
    })
}

onBeforeMount(() => {
    defineHeaders()

    getBonusReportTemplate()
})

onMounted(() => {
    userStore.getUserId().then(result => {
        userId.value = result.responseData  
    }).catch(error => {
        console.log('getUserId', error)
    })

    if (systemStore.userDetail.userType.trim() != 'Partner') {
        showFPB.value = true
        showLatitude.value = true
        showOptiplex.value = true
    }
    else {
        systemStore.getPartnerBonusQualifier(systemStore.userDetail.affinityId).then(result => {
            if (result.success) {
                showFPB.value = result.partnerBonusQualifier.csgFirstPurchaseBonus || result.partnerBonusQualifier.serverFirstPurchaseBonus || result.partnerBonusQualifier.storageFirstPurchaseBonus
                showLatitude.value = result.partnerBonusQualifier.latitudeBonus
                showOptiplex.value = result.partnerBonusQualifier.optiPlexBonus
            }         

        }).catch(error => {
            console.log('getUserId', error)
        })
    }

    systemStore.getQuarters().then(result => {
        if (result.success) {
            quarters.value = result.quarters
                .filter(q => q.currentQuarters === true && q.currentQuarter === false)
                .map(q => q.quarter)

           selectedQuarter.value = quarters.value[0]

           setTimeout(() => {
            getReportData()
          }, 2000)           
        }
    }).catch(error => {
        console.log('getQuarters', error)
    })    
})

const downloadFile = () => {
    if (reportData.value.length === 0) {
        return
    }

    excelStore.generateInMemoryExcelDocumentV2(reportData.value, 'Bonus Report').catch(error => {
        console.log('Generate In Memory Excel Document', error)
    })
}

const clickSubmit = () => {
    getReportData()
}

const getBonusReportTemplate = () => {
    reportsStore.getReports(':BonusReport:').then(result => {
        if (result.success === true) {
            if (result.hasData) {
                selectedReport.value = JSON.parse(result.reportData)[0];
                if (selectedReport.value.Params.length > 0) {
                    selectedReport.value.Params = JSON.parse(selectedReport.value.Params) 
                }
            }
        }
    }).catch(error => {
        console.log(`getBonusReportTemplate`, error)
    })
}

const getReportData = () => {

    if (selectedReport.value.Params.length > 0) {
        selectedReport.value.Params.forEach((p) => {
            if (p.Name === 'Quarter') {
                p.Value = selectedQuarter.value
            }
            else if (p.Name === 'UserId') {
                p.Value = userId.value
            }
        })
    }
    
    reportData.value = []

    reportsStore.getReportData(selectedReport.value, false, false).then(result => {
    if (result.success === true) {
        if (result.hasData) {
            reportData.value = JSON.parse(result.reportData)
        }            
    }
    }).catch(error => {
        console.log(`getReportData`, error)
    })
}
</script>

<style scoped>

</style>